import { render, staticRenderFns } from "./pointSetting.vue?vue&type=template&id=77d8fffd&scoped=true"
import script from "./pointSetting.vue?vue&type=script&lang=js"
export * from "./pointSetting.vue?vue&type=script&lang=js"
import style0 from "./pointSetting.vue?vue&type=style&index=0&id=77d8fffd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d8fffd",
  null
  
)

export default component.exports